import { render, staticRenderFns } from "./AccessibilityStatement.vue?vue&type=template&id=58d3e002&scoped=true&"
import script from "./AccessibilityStatement.vue?vue&type=script&lang=js&"
export * from "./AccessibilityStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d3e002",
  null
  
)

export default component.exports